import React from "react";

function BS4_Colors() {
  return (
    <div>
      <h1>BS4_Colors Component</h1>
      <p>This is the BS4_Colors tutorial page content.</p>
    </div>
  );
}

export default BS4_Colors;
